import {
  respondentNotificationSettings,
  selfNotificationSettings
} from '../email-notifications';
import { commonFieldsSettings } from '../fields';
import { integrationsSettings } from '../integrations';
import { submitActionsSettings } from '../submit-actions';
import { submitButtonSettings } from '../submit-button';

export const formSettings = {
  ...selfNotificationSettings,
  ...respondentNotificationSettings,
  ...commonFieldsSettings,
  ...integrationsSettings,
  ...submitActionsSettings,
  ...submitButtonSettings,

  fields: [],
  urlParams: [],
  recaptcha: false
};
